var _path, _path2, _path3, _path4, _line, _line2, _line3, _path5, _path6, _path7, _path8, _line4, _line5, _line6, _path9, _path0, _path1, _path10, _line7, _line8, _line9, _path11, _path12, _path13, _path14, _line0, _line1, _line10, _path15, _path16, _path17, _path18, _line11, _line12, _line13, _circle, _path19, _path20, _path21, _path22, _line14, _line15, _line16, _path23, _path24, _path25, _path26, _line17, _line18, _line19, _path27, _path28, _path29, _path30, _line20, _line21, _line22, _path31, _path32, _path33, _path34, _line23, _line24, _line25, _path35, _path36, _path37, _path38, _line26, _line27, _line28, _path39, _path40, _path41, _path42, _line29, _line30, _line31, _path43, _path44, _path45, _path46, _line32, _line33, _line34, _path47, _path48, _path49, _path50, _line35, _line36, _line37, _circle2, _path51, _path52, _path53, _path54, _line38, _line39, _line40, _path55, _path56, _path57, _path58, _line41, _line42, _line43, _path59, _path60, _path61, _path62, _line44, _line45, _line46, _path63, _path64, _path65, _path66, _line47, _line48, _line49, _circle3, _path67, _path68, _path69, _path70, _line50, _line51, _line52, _path71, _path72, _path73, _path74, _line53, _line54, _line55, _path75, _path76, _path77, _path78, _line56, _line57, _line58, _path79, _path80, _path81, _path82, _line59, _line60, _line61, _path83, _path84, _path85, _path86, _line62, _line63, _line64, _path87, _path88, _path89, _path90, _line65, _line66, _line67, _path91, _path92, _path93, _path94, _line68, _line69, _line70, _path95, _path96, _path97, _path98, _line71, _line72, _line73, _circle4, _path99, _path100, _path101, _path102, _line74, _line75, _line76, _path103, _path104, _path105, _path106, _line77, _line78, _line79, _path107, _line80, _line81, _line82, _path108, _path109, _path110, _path111, _line83, _line84, _line85, _path112, _path113, _path114, _path115, _line86, _line87, _line88, _path116, _path117, _path118, _path119, _line89, _line90, _line91, _path120, _path121, _path122, _path123, _line92, _line93, _line94, _path124, _path125, _path126, _path127, _line95, _line96, _line97, _circle5, _path128, _path129, _path130, _path131, _line98, _line99, _line100, _path132, _path133, _path134, _path135, _line101, _line102, _line103, _path136, _path137, _path138, _path139, _line104, _line105, _line106, _path140, _path141, _path142, _path143, _line107, _line108, _line109, _path144, _path145, _path146, _path147, _line110, _line111, _line112, _path148, _path149, _path150, _path151, _line113, _line114, _line115, _path152, _path153, _path154, _path155, _line116, _line117, _line118, _path156, _path157, _path158, _path159, _line119, _line120, _line121, _circle6, _path160, _path161, _path162, _path163, _line122, _line123, _line124, _path164, _path165, _path166, _path167, _line125, _line126, _line127, _path168, _path169, _path170, _path171, _line128, _line129, _line130, _path172, _path173, _path174, _path175, _line131, _line132, _line133, _circle7, _path176, _path177, _path178, _path179, _line134, _line135, _line136, _path180, _path181, _path182, _path183, _line137, _line138, _line139, _path184, _path185, _path186, _path187, _line140, _line141, _line142, _path188, _path189, _path190, _path191, _line143, _line144, _line145, _path192, _path193, _path194, _path195, _line146, _line147, _line148, _path196, _path197, _path198, _path199, _line149, _line150, _line151, _path200, _path201, _path202, _path203, _line152, _line153, _line154, _path204, _path205, _line155, _line156, _line157, _circle8, _path206, _path207, _line158, _line159, _line160, _path208, _path209, _path210, _path211, _path212, _line161, _line162, _line163, _path213, _line164, _line165, _line166;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactNormalDeschisActionarePrinRoleSenzori(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.60019,
    cy: 44.4,
    r: 7.4,
    stroke: "black",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.60019,
    cy: 44.4,
    r: 7.4,
    stroke: "black",
    strokeWidth: 2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.60019,
    cy: 44.4,
    r: 7.4,
    stroke: "black",
    strokeWidth: 2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.60019,
    cy: 44.4,
    r: 7.4,
    stroke: "black",
    strokeWidth: 2
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.60019,
    cy: 44.4,
    r: 7.4,
    stroke: "black",
    strokeWidth: 2
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.60019,
    cy: 44.4,
    r: 7.4,
    stroke: "black",
    strokeWidth: 2
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.60019,
    cy: 44.4,
    r: 7.4,
    stroke: "black",
    strokeWidth: 2
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line153 || (_line153 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line154 || (_line154 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line155 || (_line155 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line156 || (_line156 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line157 || (_line157 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.60019,
    cy: 44.4,
    r: 7.4,
    stroke: "black",
    strokeWidth: 2
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line158 || (_line158 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line159 || (_line159 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line160 || (_line160 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28L38.6028 48.7332",
    stroke: "black",
    strokeWidth: 2
  })), _line161 || (_line161 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line162 || (_line162 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line163 || (_line163 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line164 || (_line164 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line165 || (_line165 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line166 || (_line166 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactNormalDeschisActionarePrinRoleSenzori);
export default __webpack_public_path__ + "static/media/contact_normal_deschis_actionare_prin_role_senzori.833929800acd21f59ee471ae7b7557d7.svg";
export { ForwardRef as ReactComponent };